module.exports = __webpack_public_path__ + "img/course-pop.b6933f6.svg";